import styled from '@emotion/styled';
import {
  Button,
  Dialog as _Dialog,
  DialogContent as _DialogContent,
  DialogContentText,
  Divider,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { Deliverable, File, Maybe, User } from '../../../../graphql/generated/graphql';
import AvatarAndName from '../../../component/compound/AvatarAndName';
import ImageScreen from '../../../component/primitive/ImageScreen';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';

type Props = {
  open: boolean;
  onRequestClose: () => void;
  assignee: Pick<User, 'profileImageUrl' | 'name'>;
  deliverable: Pick<Deliverable, 'intent'> & {
    attachedThumbnail?: Maybe<{
      file: Pick<File, 'url'>;
    }>;
  };
  className?: string;
};

export const IntentDialog: FC<Props> = ({ open, onRequestClose, assignee, deliverable, className }) => {
  return (
    <Dialog open={open} onClose={onRequestClose} className={className}>
      <CloseButton color="default" onClick={onRequestClose}>
        <CloseIcon />
      </CloseButton>
      <DialogContent>
        <AvatarAndName user={assignee} />
        {deliverable.attachedThumbnail?.file?.url && (
          <Fragment>
            <SubHeading variant="subtitle2">
              <FormattedMessage id="offer_detail_page.creation.intent_dialog.attached_file" />
            </SubHeading>
            <CreativeThumbnail src={deliverable.attachedThumbnail.file.url} clickable />
            <Divider />
          </Fragment>
        )}
        <SubHeading variant="subtitle2">
          <FormattedMessage id="offer_detail_page.creation.intent_dialog.intent" />
        </SubHeading>
        <DialogIntentText variant="body1">{deliverable.intent}</DialogIntentText>
      </DialogContent>
    </Dialog>
  );
};

const Dialog = styled(_Dialog)({
  margin: SPACING_UNIT * 4,
});

const SubHeading = styled(Typography)({
  margin: SPACING_UNIT,
});

const DialogContent = styled(_DialogContent)({
  minWidth: 500,
  minHeight: 300,
  padding: SPACING_REGULAR,
});

const DialogIntentText = styled(DialogContentText)({
  padding: SPACING_UNIT,
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word' as any,
  wordBreak: 'break-word',
});

const CloseButton = styled(Button)({
  top: 0,
  right: 0,
  position: 'absolute',
  padding: SPACING_UNIT,
  minWidth: SPACING_UNIT * 3,
  minHeight: SPACING_UNIT * 3,
});

const CreativeThumbnail = styled(ImageScreen)({
  margin: SPACING_UNIT,
  marginLeft: SPACING_REGULAR,
  maxWidth: 300,
  padding: SPACING_UNIT,
});
